export { dataQa } from 'bloko/blocks/customSelect/constants';
export { DropLayer } from 'bloko/blocks/drop/constants';

const { CustomSelectOption, CustomSelectOptionSecondaryText, CustomSelectLayer } = jest.requireActual(
    'bloko/blocks/customSelect/index.js'
);
export { CustomSelectOption, CustomSelectOptionSecondaryText, CustomSelectLayer };

const renderPlaceholder = (placeholderTemplate, value) =>
    typeof placeholderTemplate === 'function' ? placeholderTemplate(value) : undefined;

const mockCustomSelect = () => {
    const mockWrapper = ({ ...props }) => (
        <bloko-component-mock
            {...props}
            placeholder={renderPlaceholder(props.placeholderTemplate, props.value)}
            _component="CustomSelect"
        />
    );
    mockWrapper.displayName = 'bloko-component-mock';
    return mockWrapper;
};

export default mockCustomSelect();
